/**
 * Generischer Vergleichs-Helfer für clientseitiges Klick-auf-Spaltenkopf-
 * Sortieren (siehe B2bRunDetail.jsx / B2cRunDetail.jsx). Kein eigenes
 * Sortier-State-Management - das bleibt lokal in der jeweiligen Seite -,
 * nur der eigentliche Vergleich pro Datentyp, damit er nicht doppelt
 * gepflegt werden muss.
 *
 * null/undefined gelten immer als "leer" und landen unabhängig von der
 * Sortierrichtung am Ende der Liste.
 *
 * @param {*} a
 * @param {*} b
 * @param {'text'|'number'} type
 * @return {number}
 */
export function compareForSort(a, b, type = 'text') {
    const aEmpty = a === null || a === undefined || a === '';
    const bEmpty = b === null || b === undefined || b === '';
    if (aEmpty && bEmpty) {
        return 0;
    }
    if (aEmpty) {
        return 1;
    }
    if (bEmpty) {
        return -1;
    }

    if (type === 'number') {
        return Number(a) - Number(b);
    }

    return String(a).localeCompare(String(b), 'de', {numeric: true, sensitivity: 'base'});
}
